import React from "react";
import { Link } from "react-router-dom";
import "../abort404/styles.css";

// Страница «нет доступа»: рисуется Content при codeApi === 403.
export default function Abort403() {
    return <div className="abort">
        <div className="abort__code">403</div>
        <div className="abort__text">Недостаточно прав для просмотра страницы</div>
        <Link className="abort__link" to="/">На главную</Link>
    </div>;
}
